import PropTypes from 'prop-types';
import DefaultTemplate from '../Default/DefaultTemplate';

const TextInner = (props) => {
  return <DefaultTemplate {...props} imageBackground />;
};

TextInner.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default TextInner;
